import React, { useState, useEffect, useRef, useContext } from "react";
import default_vertical_img from "../assets/placehoder_vertical.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { Translate } from "./LanguageChanger";
import premium from "../assets/Premium.png";
import rent from "../assets/Rent.png";
import upcomingImg from "../assets/upcoming.png";
import imgLive from "../assets/img_live.gif";
import $ from "jquery"; 
import Wrapper from "./shared/Wrapper";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";

let deviceType = window.DEVICE_TYPE;
let title;

// --- 1. CSS STYLES ---
const stylesCSS = `
  /* Hide Scrollbars */
  .tv-grid-scroll-container::-webkit-scrollbar { display: none; }
  .tv-grid-scroll-container { -ms-overflow-style: none; scrollbar-width: none; }

  /* Shimmer Animation */
  @keyframes shimmerAnimation {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
  .shimmer-container {
    position: relative; width: 100%; height: 100%;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 10px; overflow: hidden;
  }
  .shimmer-effect {
    position: absolute; top: 0; left: 0; width: 100%; height: 100%;
    background: linear-gradient(90deg, transparent 0%, #000037 50%, transparent 100%);
    animation: shimmerAnimation 1.5s infinite linear;
    z-index: 1;
  }
`;

const ShimmerImage = ({ src, alt, style, onClick, onErrorFallback }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  return (
    <div className="shimmer-container" style={{ ...style, position: "relative" }}>
      {!isLoaded && !hasError && <div className="shimmer-effect"></div>}
      <img
        decoding="async"
        loading="lazy"
        src={hasError ? onErrorFallback : src}
        alt={alt}
        onClick={onClick}
        onLoad={() => setIsLoaded(true)}
        onError={() => { setHasError(true); setIsLoaded(true); }}
        style={{
          width: "100%", height: "100%", borderRadius: "10px", objectFit: "cover",
          opacity: isLoaded ? 1 : 0, transition: "opacity 0.5s ease-in-out",
          position: "absolute", top: 0, left: 0, zIndex: 2,
        }}
      />
    </div>
  );
};

const CustomMarkupGrid = ({
  rowWidth, rowHeight, gapBetweenRow, columnWidth, columnHeight, gapBetweenColumn,
  itemWidth, itemHeight, numRows, fontSize, fontColor, selectionStyle, numColumns,
  shouldFocus, data, marginLeft, marginTop, rowBgImage, columnBgImage, columnBgColor,
  selectionColor, gapBetweenCatTitleAndItemList, animationSpeed, handleBackButton,
  handleMarkupGridUPButton, IsLiveEvent, handleLeft, isLogedIn, handleMarkupGridOKButton,
  rememberRowFocus, setRememberRowFocus, rememberColFocus, setRememberColFocus,
  screen, isBackButtonSelected, handleMarkupGridDownButton
}) => {
  
  const [selectedRowIndex, setSelectedRowIndex] = useState(rememberRowFocus > 0 ? rememberRowFocus : 0);
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(rememberColFocus > 0 ? rememberColFocus : 0);
  const [startIndexes, setStartIndexes] = useState([]);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [scrolling, setScrolling] = useState(false);
  const gridRef = useRef(null);
  const isInitialMount = useRef(true);

  // --- 2. STABLE VERTICAL SCROLL ---
  const scrollToRow = (rowIndex) => {
    const container = gridRef.current;
    if (!container) return;

    const rowElement = document.getElementById(`category-wrapper-${rowIndex}`);
    if (!rowElement) return;

    const rowTop = rowElement.offsetTop;
    const rowHeightTotal = rowElement.offsetHeight + gapBetweenRow; 
    const containerHeight = container.clientHeight;
    const currentScroll = container.scrollTop;

    // Logic: If the row is not fully visible, scroll to it.
    let targetScroll = currentScroll;

    // If Row is below viewport -> Align TOP of row to TOP of viewport (Snappy feel)
    if (rowTop + rowHeightTotal > currentScroll + containerHeight) {
        targetScroll = rowTop - 20; // 20px padding
    } 
    // If Row is above viewport -> Align TOP of row to TOP of viewport
    else if (rowTop < currentScroll) {
        targetScroll = rowTop - 20;
    }

    if (Math.abs(targetScroll - currentScroll) > 5) {
        // Use 'linear' for faster, snappier feedback on rapid key presses
        $(container).stop(true, false).animate({ scrollTop: targetScroll }, 200, "linear");
    }
  };

  useEffect(() => {
    if (shouldFocus) gridRef.current?.focus();
  }, [shouldFocus]);

  useEffect(() => {
    const initialRowIndex = rememberRowFocus > 0 ? Math.min(rememberRowFocus, data.length - 1) : 0;
    const initialColIndex = rememberColFocus > 0 ? Math.min(rememberColFocus, (data[initialRowIndex]?.shows?.length || 1) - 1) : 0;

    setSelectedRowIndex(initialRowIndex);
    setSelectedColumnIndex(initialColIndex);

    const newStartIndexes = data.map((row, index) => {
      if (index === initialRowIndex && rememberColFocus > 0) {
        return Math.max(0, Math.min(rememberColFocus - Math.floor(numColumns / 2), row.shows.length - numColumns));
      }
      return 0;
    });

    setStartIndexes(newStartIndexes);

    if (isInitialMount.current && rememberRowFocus > 0) {
      setTimeout(() => {
        scrollToRow(initialRowIndex);
        if (rememberColFocus > 0) {
          const rowElement = $(`#row-${initialRowIndex}`);
          const scrollLeft = newStartIndexes[initialRowIndex] * (columnWidth + gapBetweenColumn);
          $(rowElement).stop().animate({ scrollLeft: scrollLeft }, 0);
        }
      }, 200);
    }
    isInitialMount.current = false;
  }, [data, numRows, rememberRowFocus, rememberColFocus]);

  const handleKeyDown = (e) => {
    if (scrolling) return;
    const currentCategory = data[selectedRowIndex];
    const rowLength = currentCategory?.shows?.length || 0;

    switch (e.keyCode) {
      case 39: handleRightKey(currentCategory, rowLength); break;
      case 37: handleLeftKey(); break;
      case 40: 
        e.preventDefault(); 
        handleDownKey(); 
        break;
      case 38: 
        e.preventDefault(); 
        handleUpKey(); 
        break;
      case 13: handleOk(); break;
      case 8:
      case 10009:
      case 461:
        gridRef.current.blur();
        handleBackButton();
        break;
      default: break;
    }
  };

  // --- 3. FIX: HORIZONTAL RESET ON VERTICAL NAV ---
  
  const handleDownKey = () => {
    if (selectedRowIndex < data.length - 1) {
      const nextRowIndex = selectedRowIndex + 1;
      const newColumnIndex = 0; // Reset to 0

      // 1. Visually Reset Horizontal Scroll immediately
      // This fixes the "Missing Focus" issue
      const nextRowElement = $(`#row-${nextRowIndex}`);
      if(nextRowElement) {
          nextRowElement.stop(true, true).scrollLeft(0);
      }

      // 2. Reset Pagination Logic for that row
      const newStartIndexes = [...startIndexes];
      newStartIndexes[nextRowIndex] = 0;
      setStartIndexes(newStartIndexes);

      // 3. Update State
      setSelectedRowIndex(nextRowIndex);
      setSelectedColumnIndex(newColumnIndex);
      
      // 4. Scroll Container
      scrollToRow(nextRowIndex);

    } else if(screen === "liveEvent") {
      if(isBackButtonSelected) setSelectedRowIndex(0);
      handleMarkupGridDownButton();
    }
  };

  const handleUpKey = () => {
    if (selectedRowIndex > 0) {
      const prevRowIndex = selectedRowIndex - 1;
      const newColumnIndex = 0; // Reset to 0
      
      // 1. Visually Reset Horizontal Scroll immediately
      const prevRowElement = $(`#row-${prevRowIndex}`);
      if(prevRowElement) {
          prevRowElement.stop(true, true).scrollLeft(0);
      }

      // 2. Reset Pagination Logic
      const newStartIndexes = [...startIndexes];
      newStartIndexes[prevRowIndex] = 0;
      setStartIndexes(newStartIndexes);

      // 3. Update State
      setSelectedRowIndex(prevRowIndex);
      setSelectedColumnIndex(newColumnIndex);

      // 4. Scroll Container
      scrollToRow(prevRowIndex);
    } else {
      handleMarkupGridUPButton();
    }
  };

  const handleRightKey = (currentCategory, rowLength) => {
    const nextIndex = selectedColumnIndex + 1;
    if (nextIndex < rowLength) {
      if (nextIndex >= startIndexes[selectedRowIndex] + numColumns) {
        scrollHorizontal("right", nextIndex);
      } else {
        setSelectedColumnIndex(nextIndex);
      }
    }
  };

  const handleLeftKey = () => {
    const prevIndex = selectedColumnIndex - 1;
    if (prevIndex >= 0) {
      if (prevIndex < startIndexes[selectedRowIndex]) {
        scrollHorizontal("left", prevIndex);
      } else {
        setSelectedColumnIndex(prevIndex);
      }
    } else if (selectedColumnIndex === 0 && !IsLiveEvent) {
      if (handleLeft !== false) {
        gridRef.current.blur();
        handleBackButton();
      }
    }
  };

  const handleOk = () => {
    const currentCategory = data[selectedRowIndex];
    gridRef.current.blur();
    if (typeof setRememberRowFocus === "function") setRememberRowFocus(selectedRowIndex);
    if (typeof setRememberColFocus === "function") setRememberColFocus(selectedColumnIndex);
    handleMarkupGridOKButton(currentCategory.shows[selectedColumnIndex]);

    if (currentCategory?.genres_id === null) {
      setSourceContext(`${sourceContext}/(${currentCategory?.id}/${currentCategory?.title?.[0]?.content})`);
    } else {
      setSourceContext(`${sourceContext}/(${currentCategory?.shows[0]?.id}/${currentCategory?.shows?.[0]?.title})`);
    }
    
    // sendTestMatomoEvent({
    //   eventCategory: `${data?.[selectedRowIndex]?.title?.[0]?.content}`,
    //   eventAction: "ContentSelected",
    //   eventName: `${currentCategory?.shows[0]?.id}/${currentCategory?.shows[0]?.title}`,
    //   url: "live-event",
    // });
  };

  const selectedOK = (rowIndex, columnIndex) => {
    const currentCategory = data[rowIndex];
    const selectedShow = currentCategory.shows[columnIndex];
    if (gridRef.current) gridRef.current.blur();
    if (typeof setRememberRowFocus === "function") setRememberRowFocus(rowIndex);
    if (typeof setRememberColFocus === "function") setRememberColFocus(columnIndex);
    handleMarkupGridOKButton(selectedShow);
  };

  const scrollHorizontal = (direction, nextIndex) => {
    const currentRow = $(`#row-${selectedRowIndex}`);
    const distance = columnWidth + gapBetweenColumn;
    setScrolling(true);

    if (direction === "right") {
      const nextStartIndex = startIndexes[selectedRowIndex] + 1;
      // We check against (start + numColumns) to see if we need to shift the window
      if (nextStartIndex + numColumns <= data[selectedRowIndex].shows.length) {
        $(currentRow).animate({ scrollLeft: `+=${distance}` }, animationSpeed, () => {
          const newStartIndexes = [...startIndexes];
          newStartIndexes[selectedRowIndex] = nextStartIndex;
          setStartIndexes(newStartIndexes);
          setSelectedColumnIndex(nextIndex);
          setScrolling(false);
        });
      } else {
        setScrolling(false);
      }
    } else if (direction === "left") {
      const prevStartIndex = startIndexes[selectedRowIndex] - 1;
      if (prevStartIndex >= 0) {
        $(currentRow).animate({ scrollLeft: `-=${distance}` }, animationSpeed, () => {
          const newStartIndexes = [...startIndexes];
          newStartIndexes[selectedRowIndex] = prevStartIndex;
          setStartIndexes(newStartIndexes);
          setSelectedColumnIndex(nextIndex);
          setScrolling(false);
        });
      } else {
        setScrolling(false);
      }
    }
  };

  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <>
      <style>{stylesCSS}</style>

      <div
        ref={gridRef}
        className="tv-grid-scroll-container"
        style={{
          width: "100vw",
          height: "79vh",
          marginLeft: marginLeft,
          marginTop: marginTop,
          overflowY: "auto", 
          overflowX: "hidden", 
         outline: "none",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        tabIndex="0"
        onKeyDown={handleKeyDown}
      >
        {data.map((category, rowIndex) => {
          const isSelectedRow = rowIndex === selectedRowIndex;
          return (
            <div
              id={`category-wrapper-${rowIndex}`}
              key={category.genres_id ? category.genres_id : rowIndex}
              style={{
                marginBottom: gapBetweenRow,
                backgroundImage: `url(${rowBgImage})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                style={{
                  fontSize: fontSize,
                  color: fontColor,
                  marginBottom: gapBetweenCatTitleAndItemList,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                {(() => {
                   title = category?.genres_name === "genres"
                      ? category?.list[0]?.genres
                      : category?.genres_name === "recent"
                      ? "Recent Live"
                      : category?.title?.find(
                          (item) => item.language === (localStorage.getItem("AppLanguage") || "English")
                        )?.content ||
                        category?.title?.find((item) => item.language === "English")?.content ||
                        category?.genres_name;

                  const translatedTitles = [
                    "Drama", "Romance", "Contemporary Fiction", "History", "Mystery", "Thriller", "Horror", "Educational", "Health", "Biography", 
                    "Musical Drama", "Music & Dance", "Dance Drama", "Music", "Sports", "Adventure", "Animation", "Literature", "Arts & Culture",
                      "Religious", "Crime", "Spiritual", "Detective", "Mythology", "Entertainment", "Historical Fiction", "Political", "Classical Music", "Comedy", "Satire", 
                      "Humor", "Autobiography", "Lifestyle", "Kids & Family", "Devotional", "Nature & Wildlife", "Travelogue", "Folk Music", "Storytelling", "Dance", "Talk Shows",
                      "Inspirational", "Reality", "Action", "Agriculture", "International", "Anime", "Period Drama", "Sci-Fi", "Patriotic", "Performing Arts", "Astrology", "Fashion", "Talent Hunt", "Cookery",
                        "Talk Show", "Superhero", "Literary Fiction", "Science", "Scientific", "Cooking", "Food", "Travel", "Paintings", "Design", "Art", "Nature", "Arts And Culture", "Educational Books", 
                        "Young Adult Fiction", "News", "Technology", "Open World", "Business", "Home Decor", "Chat Show", "Edutainment", "Social Awareness", "Event", "Hindustani Classical Music",
                        "Semi-Classical Music", "Kids", "Celebration", "Casual", "Medical", "Yojna", "Sculptures", "Art" ,"Carbatic Music", "Digital Literacy", "Legal And Ethical", "Digital art", "Parenting",
                  ];

                  if (translatedTitles.includes(title)) {
                    return <Translate langKey={title} />;
                  }

                  return capitalizeFirstLetter(title);
                })()}
              </div>

              <div
                id={`row-${rowIndex}`}
                style={{
                  display: "flex",
                  overflow: "hidden",
                  width: rowWidth,
                  height: columnHeight,
                  position: "relative",
                }}
              >
                {category.shows
                  .slice(startIndexes[rowIndex], startIndexes[rowIndex] + numColumns)
                  .map((show, columnIndex) => {
                    const absoluteColumnIndex = startIndexes[rowIndex] + columnIndex;
                    const isSelected = isSelectedRow && absoluteColumnIndex === selectedColumnIndex;

                    return (
                      <div
                        key={show.id || columnIndex}
                        style={{
                          width: columnWidth,
                          height: columnHeight,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: columnIndex < numColumns - 1 ? gapBetweenColumn : 0,
                          backgroundImage: `url(${columnBgImage})`,
                          borderRadius: "10px",
                        }}
                      >
                        <Wrapper
                          onMouseEnter={() => {
                            if (shouldFocus) {
                              setSelectedRowIndex(rowIndex);
                              setSelectedColumnIndex(absoluteColumnIndex);
                            }
                          }}
                          style={{
                            width: itemWidth,
                            height: "98%",
                            lineHeight: `${itemHeight}px`,
                            textAlign: "center",
                            backgroundColor: selectionStyle === "background" && isSelected ? selectionColor : "transparent",
                            border: selectionStyle === "border" && isSelected ? `5px solid ${selectionColor}` : "5px transparent",
                            transform: selectionStyle === "zoom" && isSelected ? "scale(1.1)" : "scale(1)",
                            transition: "transform 0.3s",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            borderRadius: "10px",
                            fontSize: fontSize,
                            color: fontColor,
                            backgroundPosition: "center",
                            position: "relative",
                            left: "0.2rem",
                          }}
                        >
                          <div style={{ position: "relative", height: "100%", width: "100%", borderRadius: "10px", overflow: "hidden" }}>
                            <ShimmerImage
                              src={
                                show.thumbnail || default_vertical_img
                              }
                              onErrorFallback={default_vertical_img}
                              alt={show.title}
                              onClick={() =>
                                selectedOK(rowIndex, absoluteColumnIndex)
                              }
                              style={{
                                width: "100%",
                                height: "100%",
                              }}
                            />

                            {show?.is_live == 1 && (
                              <img
                                src={imgLive}
                                alt="live Icon"
                                style={{
                                  position: "absolute",
                                  bottom: "14rem",
                                  left: "0.7rem",
                                  width: "5rem",
                                  height: "2rem",
                                  top: "0.7rem",
                                  zIndex: 3, // Above shimmer/image
                                }}
                              />
                            )}

                            {category?.genres_name == "upcoming" && (
                              <img
                                src={upcomingImg}
                                alt={show.title}
                                style={{
                                  borderRadius: "10px",
                                  position: "absolute",
                                  width: "7vw",
                                  height: "4vh",
                                  top: "1vh",
                                  right: "0.7rem",
                                  zIndex: 3,
                                }}
                                onClick={() =>
                                  selectedOK(rowIndex, absoluteColumnIndex)
                                }
                              />
                            )}

                            {show?.is_paid === 1 && (
                              <img
                                src={premium}
                                alt="Premium Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  zIndex: 3,
                                }}
                              />
                            )}

                            {show?.is_paid === 2 && (
                              <img
                                src={rent}
                                alt="Rent Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  zIndex: 3,
                                }}
                              />
                            )}

                            {show.isTeaser === 1 &&
                              (() => {
                                const startTime =
                                  parseInt(show?.endtime) * 1000;
                                const now = Date.now();
                                const hoursRemaining =
                                  (startTime - now) / (1000 * 60 * 60);
                                const launchesIn24Hours =
                                  startTime > 0 && startTime < window.CWPOOLING;

                                return launchesIn24Hours ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "10%",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      zIndex: 10,
                                      background: "#fff",
                                      color: "black",
                                      padding: "5px 15px",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {`LAUNCHES IN ${Math.ceil(
                                      hoursRemaining
                                    )} HOURS`}
                                  </div>
                                ) : null;
                              })()}
                            {show?.isTeaser === 1 && (
                              <img
                                src={upcomingImg}
                                alt={show.title}
                                style={{
                                  borderRadius: "10px",
                                  position: "absolute",
                                  width: "10vw",
                                  height: "4vh",
                                  top: "1vh",
                                  right: "1rem",
                                  zIndex: 3,
                                }}
                              />
                            )}
                          </div>
                        </Wrapper>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CustomMarkupGrid;